import React, { useState, useRef, useEffect } from 'react';
import './SearchableDropdown.css';

const SearchableDropdown = ({
    options,
    value,
    onChange,
    placeholder,
    disabled = false,
    loading = false,
    className = ''
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const dropdownRef = useRef(null);

    // Filtrar opciones basado en el término de búsqueda
    const filteredOptions = options.filter(option =>
        option.description.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Cerrar dropdown cuando se hace clic fuera
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
                setSearchTerm('');
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleSelect = (option) => {
        onChange(option.id);
        setIsOpen(false);
        setSearchTerm('');
    };

    const handleToggle = () => {
        if (!disabled && !loading) {
            setIsOpen(!isOpen);
            if (!isOpen) {
                setSearchTerm('');
            }
        }
    };

    const selectedOption = options.find(option => option.id === value);

    return (
        <div className={`searchable-dropdown ${className}`} ref={dropdownRef}>
            <div 
                className={`dropdown-header ${disabled ? 'disabled' : ''} ${loading ? 'loading' : ''}`}
                onClick={handleToggle}
            >
                <span className="dropdown-value">
                    {selectedOption ? selectedOption.description : placeholder}
                </span>
                <span className="dropdown-arrow">▼</span>
            </div>

            {isOpen && (
                <div className="dropdown-content">
                    <div className="search-container">
                        <input
                            type="text"
                            placeholder="Buscar..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="search-input"
                            autoFocus
                        />
                    </div>
                    
                    <div className="options-container">
                        {filteredOptions.length > 0 ? (
                            filteredOptions.map(option => (
                                <div
                                    key={option.id}
                                    className={`dropdown-option ${option.id === value ? 'selected' : ''}`}
                                    onClick={() => handleSelect(option)}
                                >
                                    {option.description}
                                </div>
                            ))
                        ) : (
                            <div className="no-results">
                                No se encontraron resultados
                            </div>
                        )}
                    </div>
                </div>
            )}

            {loading && (
                <div className="loading-indicator">
                    Cargando...
                </div>
            )}
        </div>
    );
};

export default SearchableDropdown; 